export var adminResetDefinition = {
  setup() {
    $(document).on('click', '.reset-definition', function(event) {
      var def = $(event.currentTarget).data('default');
      $(this).closest('.fieldset').find("input").val(def);
    });
  }
};
